import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';
import { fetchAcceptPublicOffer } from '../../../services/joinOtaIndividual/fetchAcceptPublicOffer';
import type { IReceiptDetailsSaveRequest } from '../../../repositories/dailyrent/v1/receipt-details/save';
import {
  fetchSaveFormData,
  TSaveFormDataValidationErrorDetails,
} from '../../../services/joinOtaIndividual/fetchSaveFormData';
import { setInnError } from '../../../slices/joinOtaIndividual';
import { IErrorDetails, ValidationError } from '@cian/peperrors';

export type TSaveFormRejectValue = {
  type: 'validationError' | 'unknownError';
  message?: string;
  details?: IErrorDetails | undefined;
};

export const saveFormAndAcceptOffer = createAsyncThunk<
  void,
  IReceiptDetailsSaveRequest,
  IThunkApi & { rejectValue: TSaveFormRejectValue }
>('joinOtaIndividual/saveFormAndAcceptOffer', async (params, thunkApi) => {
  const { dispatch, extra: context } = thunkApi;

  try {
    dispatch(setInnError(null));
    await fetchSaveFormData(context, params);
    await fetchAcceptPublicOffer(context);

    return;
  } catch (e) {
    if (e instanceof ValidationError && e.details) {
      return thunkApi.rejectWithValue({
        type: 'validationError',
        details: e.details as TSaveFormDataValidationErrorDetails,
      });
    }

    return thunkApi.rejectWithValue({ type: 'unknownError', message: e.message });
  }
});
